import { graphql } from "gql";

const ACTIVE_CALL_LIST_QUERY = graphql(`
  query ActiveCallList($input: ActiveCallListInput!) {
    activeCallList(input: $input) {
      ...Call
    }
  }
`);

export default ACTIVE_CALL_LIST_QUERY;
